
            const data = {"name":"icon-copy","data":{"width":"16","height":"16","viewBox":"0 0 16 16","data":"<path pid=\"0\" _fill=\"currentColor\" d=\"M10 4V0H3L0 3v9h6v4h10V4h-6zM3 1.414V3H1.414L3 1.414zM1 11V4h3V1h5v3L6 7v4H1zm8-5.586V7H7.414L9 5.414zM15 15H7V8h3V5h5v10z\"/>"}}
        
                module.exports = data
                